export const OwnerPermissionGroupName = 'Owner';
